import React from 'react';
import { Grid, Button, CircularProgress, withTheme } from '@material-ui/core';
import { useHistory } from 'react-router';
import moment from '../moment-hawaii';

import {
    bookerFieldsFromTickets,
    getBookerFieldDefaults,
    getBookingGuestData,
    withGuestStayDates,
    formatMoney
} from '../utils';
import { PAYMENT_METHODS, usePaymentMethods } from '../hooks/usePaymentMethod';

const AddToCartBox = ({ futureCartItem = null, customer, user, fillCart, updateBookingGuest }) => {
    const history = useHistory();
    const paymentMethods = usePaymentMethods();

    // just to protect ourselves
    if (
        !futureCartItem ||
        !futureCartItem.tickets ||
        !futureCartItem.tickets.length > 0 ||
        !futureCartItem.tickets[0]
    ) {
        return (
            <Grid
                item
                container
                className="add-to-cart-box-wrapper"
                direction="row"
                alignItems="center"
                spacing={4}
            ></Grid>
        );
    }

    const selectOrder = () => {
        fillCart([withGuestStayDates(futureCartItem, customer)]);
        const tickets = futureCartItem.tickets || [];
        const bookerDefaults = getBookerFieldDefaults(tickets);
        if (customer) {
            updateBookingGuest({
                ...bookerDefaults,
                ...getBookingGuestData(customer, bookerFieldsFromTickets(tickets))
            });
        } else if (Object.keys(bookerDefaults).length > 0) {
            updateBookingGuest(bookerDefaults);
        }
        history.push(`/review/last`);
    };

    return (
        <Grid
            item
            container
            className="add-to-cart-box-wrapper"
            direction="row"
            alignItems="center"
            spacing={4}
        >
            <Grid item container direction="column" xs={12} sm={8} spacing={2}>
                <Grid item className="strong">
                    {futureCartItem.activity.name}
                    {` (${formatMoney(futureCartItem.tickets[0].retail_price)}/pp)`}
                </Grid>

                <Grid item className="times">
                    <span>{moment(futureCartItem?.start_time).format('ddd, MMMM DD, YYYY')}</span>
                    <span>|</span>
                    <span>{moment(futureCartItem?.start_time).format('h:mm a')}</span>
                </Grid>
            </Grid>
            <Grid
                item
                container
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                xs={12}
                sm={4}
                spacing={2}
            >
                <Grid item className="strong subtotal">
                    Subtotal:
                    {formatMoney(
                        futureCartItem.tickets[0].quantity * futureCartItem.tickets[0].retail_price
                    )}
                </Grid>

                <Grid item>
                    {!paymentMethods.find(e => e.methodtype === PAYMENT_METHODS.card) &&
                    user &&
                    user.role !== 'agent' ? (
                        <h4>Visit the concierge desk to do reservations!</h4>
                    ) : futureCartItem ? (
                        <Button
                            fullWidth
                            className="btn-golf-rounded"
                            variant="contained"
                            color="primary"
                            style={{ color: 'white' }}
                            onClick={selectOrder}
                        >
                            Book Tee Time
                        </Button>
                    ) : (
                        <CircularProgress />
                    )}
                </Grid>
            </Grid>
            {futureCartItem.warning && (
                <Grid item container className="all-times">
                    {futureCartItem.warning}
                </Grid>
            )}
        </Grid>
    );
};

export default withTheme(AddToCartBox);
